import { hookstate } from '@hookstate/core'

const globalTransactionStore = hookstate({
    allTransactions: null,
    filteredTransactions: [],
    forceUpdate: false,
    transactionFilter: { Search: '', TransactionType: [], Status: [], Date: null }
});

export default globalTransactionStore;